import React from "react";
import { Typography, Box } from "@mui/material";
import styles from "../../Style/Modules/introcard.module.css";
import "../../Style/Theme/index.css";

export default function IntroCard({ title, subtitle, img, screen = "" }) {
  return (
    <Box
      // className={styles.introcardBox1}
      sx={{
        paddingTop: screen === "bankUpload" ? "0px" : "64px",
        paddingBottom: "40px",
        display: "flex",
        flexdirection: "row",
        alignitems: "start",
        justifycontent: "space-between",
        marginTop: "64px",
        // backgroundColor: "red",
      }}
    >
      <Box className={`${styles.introcardBoxMain} introcardBox_Th`}>
        <Box className={styles.introcardBox2}>
          <Typography
            variant="h2"
            className={`${styles.introcardTitle} title_Th`}
          >
            {title}
          </Typography>
          <Typography
            variant="p"
            className={`${styles.introcardSubtitle} subTitle_Th`}
          >
            {subtitle}
          </Typography>
        </Box>
        <img src={img} alt="img" />
      </Box>
    </Box>
  );
}
